import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgExitMobileVerificationModal',
})
export default class CmgExitMobileVerificationModal extends Vue {

  get visible(): boolean {
    return this.$appStore.state.ui.modals.exitMobileVerificationModal.visible;
  }
  
  get closeButtonImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.xDarkBrown.default;
  }

  leave() {
    this.$appStore.state.ui.modals.exitMobileVerificationModal.args?.onLeave();
    this.$services.ui.setModalVisibility('exitMobileVerificationModal', false);
  }

  resume() {    
    this.$services.ui.setModalVisibility('exitMobileVerificationModal', false);
    Vue.nextTick(() => {
      setTimeout(() => {
        this.$services.ui.focusBack();
      }, 1000);
    });
  }
}
